module.exports = __webpack_public_path__ + "img/n5.19b4c895.png";